import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SessionStorage } from './SessionStorage';
export class SessionValue {
  constructor(key) {
    _defineProperty(this, "key", void 0);

    _defineProperty(this, "storage", new SessionStorage());

    _defineProperty(this, "remove", () => {
      this.storage.removeItem(this.key);
      return this;
    });

    _defineProperty(this, "get", () => this.storage.getItem(this.key));

    _defineProperty(this, "set", value => {
      this.storage.setItem(this.key, value);
      return this;
    });

    this.key = key;
  }

}
//# sourceMappingURL=SessionValue.js.map